import React, { useState } from "react"
import { withBasicNotify } from "components/notification"
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardTitle,
  CardBody
} from "reactstrap"
import classnames from "classnames"
import { dataImportType } from "utils/dataImportType"
import UploadSection from "./UploadSection"

const DataImportContainer = () => {
  const [activeTab, setActiveTab] = useState(0)

  const renderNavItem = () => {
    return dataImportType.map((item, index) => (
      <NavItem key={index}>
        <NavLink
          className={classnames({
            active: activeTab === index
          })}
          style={{ cursor: "pointer" }}
          onClick={() => {
            setActiveTab(index)
          }}
        >
          <i className={`${item.iconClass} mr-2`}> </i>
          {item.typeName}
        </NavLink>
      </NavItem>
    ))
  }

  const renderTabPane = () => {
    return dataImportType.map((item, index) => (
      <TabPane key={index} tabId={index}>
        <UploadSection
          key={index}
          typeName={item.typeName}
          description={item.description}
          sampleUrl={item.sampleUrl}
          uploadType={item.uploadType}
        />
      </TabPane>
    ))
  }

  return (
    <Card>
      <CardTitle className="bg-light border-bottom p-3 mb-0">
        <i className="mdi mdi-cloud-upload mr-2"> </i>
        資料匯入
      </CardTitle>

      <CardBody className="">
        <Nav tabs>{renderNavItem()}</Nav>
        <TabContent activeTab={activeTab}>{renderTabPane()}</TabContent>
      </CardBody>
    </Card>
  )
}

export default withBasicNotify(DataImportContainer)
